import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { useGetLangText } from './FaqLiveagentPrompt';

function FaqQuestionList(props: BaseMsgProps) {
  const { faqQuestionListContent } = props.raw;

  const getLangText = useGetLangText();

  if (!faqQuestionListContent) {
    return <></>;
  }

  const { fixedTitle, questions } = faqQuestionListContent;

  return (
    <MessageExtendComplex
      {...props}
      content={
        <Container>
          <div>{getLangText(fixedTitle)}</div>
          <ul>
            {questions.map(({ text }) => (
              <li>{text}</li>
            ))}
          </ul>
        </Container>
      }
    />
  );
}

const Container = styled.div`
  max-width: 450px;
  border-radius: 4px;
  background: var(--fett-bg-panel);
  > div {
    padding: 8px 12px;
    border-bottom: solid 1px var(--fett-border-default);
  }
  > ul {
    margin: 0;
    padding: 0 12px;
    list-style: none;
    > li {
      padding: 8px 0;
      color: var(--fett-text-tertiary);
      & + li {
        border-top: solid 1px var(--fett-border-default);
      }
    }
  }
`;

export default FaqQuestionList;
